import {NavigationPathKey, TranslationKey} from '@enums'
import {SearchTableWrapper} from '@wrappers'

import React from 'react'

import {UIKit} from '@components'

import {useParentCompanySearchModel} from './parent-company-search-model'

/**
 * Parent Company Search page
 */
export function ParentCompanySearchPage() {
  const {navigate, t, showCreateButton, rows, columns} = useParentCompanySearchModel()

  return (
    <SearchTableWrapper>
      <UIKit.Table
        {...(showCreateButton && {
          buttonProps: {
            buttonText: t(TranslationKey['Add new partner']),
            onClick: () => navigate(NavigationPathKey.PARENT_COMPANY_CREATION),
          },
        })}
        columns={columns}
        rows={rows}
        title={t(TranslationKey['List of Amplio partners'])}
      />
    </SearchTableWrapper>
  )
}
